export const wrapperStyles = {
  display: 'flex',
  alignItems: 'center',
};

export const avatarGroupStyles = {
  '& .MuiAvatar-root': {
    marginRight: '-10px',
    boxSizing: 'border-box !important',
    height: '33px',
    width: '33px',
    fontSize: '1.4rem',
    fontWeight: 500,
    fontFamily: 'Roboto, sans-serif !important',
    cursor: 'pointer',
    backgroundColor: ({ palette }) => palette.background.paper,
    color: ({ palette }) => palette.text.secondary,
  },
};

export const avatarWrapperStyles = {
  position: 'relative',
  display: 'inline-flex',
};

const statusBadgeBaseStyles = {
  position: 'absolute',
  bottom: '0px',
  right: '-2px',
  width: '10px',
  height: '10px',
  borderRadius: '50%',
  border: '2px solid',
  borderColor: ({ palette }) => palette.background.primary,
  zIndex: 1,
};

export const getStatusBadgeStyles = ({ isActive, isIdle }) => {
  if (isActive) {
    return { ...statusBadgeBaseStyles, backgroundColor: ({ palette }) => palette.success.main };
  }

  if (isIdle) {
    return { ...statusBadgeBaseStyles, backgroundColor: ({ palette }) => palette.warning.main };
  }

  return { ...statusBadgeBaseStyles, backgroundColor: ({ palette }) => palette.grey[400] };
};

export const getPresenceBorderStyles = ({ userColor }) => ({
  borderWidth: '2px !important',
  borderStyle: 'solid !important',
  borderColor: userColor
    ? `${userColor} !important`
    : ({ palette }) => `${palette.grey[300]} !important`,
});

export const tooltipHeaderStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginBottom: '8px',
};

export const tooltipRolesStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '4px',
};

export const tooltipDetailStyles = {
  display: 'block',
  marginTop: '4px',
};

export const tooltipStatusStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  marginTop: '4px',
  fontSize: '1.2rem',
};

export const tooltipStatusDotStyles = {
  width: '8px',
  height: '8px',
  borderRadius: '50%',
  flexShrink: 0,
};

export const getTooltipAvatarColorStyles = ({ userColor }) => ({
  ...(!userColor ? {} : { backgroundColor: userColor.bg, color: userColor.fg }),
});

export const getTooltipStatusDotColorStyles = ({ isActive, isIdle }) => {
  if (isActive) {
    return { backgroundColor: ({ palette }) => palette.success.main };
  }

  if (isIdle) {
    return { backgroundColor: ({ palette }) => palette.warning.main };
  }

  return { backgroundColor: ({ palette }) => palette.grey[400] };
};

export const avatarGroupSlotProps = {
  surplus: {
    sx: {
      '--AvatarGroup-spacing': '4px',
    },
  },
};

export const surplusContentStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
};

export const surplusTooltipStyles = {
  width: '295px',
  padding: '12px',
  backgroundColor: ({ palette }) => palette.background.paper,
  borderRadius: '8px',
  boxShadow: ({ palette }) => palette.shadow.m,
};

export const surplusListStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

export const surplusRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

export const surplusRowTextStyles = {
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
};

export const surplusNameStyles = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const getSurplusAvatarStyles = ({ userColor }) => ({
  height: '24px',
  width: '24px',
  flexShrink: 0,
  ...getTooltipAvatarColorStyles({ userColor }),
});

export const getSurplusStatusDotStyles = ({ isActive, isIdle }) => ({
  ...tooltipStatusDotStyles,
  ...getTooltipStatusDotColorStyles({ isActive, isIdle }),
});
